<script>
import {
  router,
  findDefaultChannelOfTypeForRally,
  findDefaultChannelObjOfType,
  slugToTypeObjectMap,
  channelTypeObjectMap,
  getChannelSlug
} from "../common";
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapState("rallies", ["rallyChannelsByRallyId"]),
    contentId() {
      return parseInt(this.$route.params.id);
    },
    channelTypePlural() {
      return channelTypeObjectMap()[this.channelType].channelTypePlural;
    },
    channelSlug() {
      return getChannelSlug(this.$route)
    },
    channelId() {
      return this.channel.id
    },
    channelType() {
      return this.channel.type
    },
    channelIdOld() {
      if (this.rallyChannelsByRallyId && this.rallyChannelsByRallyId[parseInt(this.rallyId)]) {
        let chanid = findDefaultChannelOfTypeForRally(
          this.channelTypePlural,
          this.rallyChannelsByRallyId,
          this.rallyId
        );
        if (!chanid && this.altChannelTypePlural){
          chanid =  findDefaultChannelOfTypeForRally(
          this.altChannelTypePlural,
          this.rallyChannelsByRallyId,
          this.rallyId
        );
        }
        return chanid 
      } else {
        return null
      }
    },
   /* contextId(){
      return this.channelId
    }*/
  },
  methods: {
    ...mapActions("contents", ["setContentById", "flagContent"]),
    ...mapActions("rallies", ["fetchRalliesChannels"]),
    async loadContents() {
      // Add a retry mechanism for when channels aren't loaded yet
      let retryCount = 0;
      const maxRetries = 5;
      const retryDelay = 500; // 500ms

      while (retryCount < maxRetries) {
        if (this.channel) {
          this.contextId = this.channelId;
          this.myFetchContents();
          return; // Success, exit the method
        } else {
          // Try to fetch channels if they're not loaded
          try {
            await this.fetchRalliesChannels({ rallyId: this.rallyId });

            let channels = this.rallyChannelsByRallyId[ this.rallyId];
            if (channels && channels.length > 0) {
              for (const channel of channels) {
                if ((this.channelType == channel.attributes.type) ||
                    (this.channelType === 'special_events' && channel.attributes.slug === 'fundraisers?fundraiser_type=PayableEvent') ||
                    (this.channelType=== 'pay' && channel.attributes.slug === 'fundraisers?fundraiser_type=PayableGroup') ||
                    (this.channelType === 'give' && channel.attributes.slug === 'fundraisers?fundraiser_type=GivePayableGroup')) {
                  this.channelId = channel.id;
                  this.contextId = this.channelId;
                  this.myFetchContents();
                  return; // Success, exit the method
                }
              }
            }
          } catch (error) {
            console.error('Error fetching channels:', error);
          }
        }

        // Wait before retrying
        retryCount++;
        if (retryCount < maxRetries) {
          console.log(`Waiting for channels to load... retry ${retryCount}/${maxRetries}`);
          await new Promise(resolve => setTimeout(resolve, retryDelay));
        }
      }

      console.error('Failed to load channels after retries');
    },
    myReloadPageData(){

    },
    async loadPageData() {
      console.log("loadPageData called in MIXIN!!!!!!!!!");
      this.loadAttempted = true; 
      try {
        await this.myReloadPageData()
        await this.loadContents();
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>
